const messages = {
    ERROR: {
        SERVER: 'Error al conectarse al servidor',
        NOT_LOGGED: 'Debe iniciar sesión. Actualice la página',
        NO_TEXT: 'El escrito seleccionado no contiene texto.'
    },
    LOADING: {
        USER_DATA: 'Cargando datos de usuario',
        DELETING_PROCEEDING: 'Eliminando expediente',
        SEARCHING: 'Buscando',
        LOAD_MORE: 'Cargando más',
        DOWNLOADING: 'Descargando',
        GETTING_LINK: 'Obteniendo enlace'
    },
    ACTIONS: {
        ADD_PROCEEDING: 'Agregando expediente',
        REMOVE_PROCEEDING: 'Quitar expediente',
        ADD_PROCEEDING_CONFIRM: 'El mismo se agregará al listado de "Mis Expedientes"'
    },
    SUCCESS: {
        PROCEEDING_ADDED: 'Expediente agregado correctamente!!',
        PROCEEDING_DELETED: 'Expediente eliminado correctamente!!'
    },
    NOT_ACCESS: 'Por favor contáctese con la Unidad Judicial para mayor información acerca de este expediente.',
    NOT_RECORDS: 'No se encontraron resultados para la búsqueda.',
    NEW_VERSION: 'Existe una nueva vesión del sistema',
    NOT_REVERSIBLE: 'La operación no se podrá revertir',
    SEARCH_BY_COVER: 'Buscar por carátula'
};

export default messages;